import { Pipe, PipeTransform } from '@angular/core';
import { toArray } from 'lodash';

@Pipe({ name: 'arrayObject' })
export class ArrayObjectPipe implements PipeTransform {

  transform(value: any): any[] {
    return toArray(value);
  }

}



// WEBPACK FOOTER //
// ./src/pipes/array-object.pipe.ts